import styled from "styled-components";
export const NakedButton = styled.button.attrs((props) => ({
    type: props.type ?? "button"
})) `
  align-items: center;
  appearance: none;
  background-color: transparent;
  border: none;
  cursor: pointer;
  display: ${({ inline }) => (inline ? "inline-flex" : "flex")};
  font-size: inherit;
  font-weight: inherit;
  font-family: inherit;
  justify-content: center;
  line-height: inherit;
  text-align: center;
  > * {
    align-self: center;
  }
  &:where(:active:not(:disabled)) {
    color: inherit;
  }
  ${({ noPadding }) => noPadding && `padding: 0;`};
`;
